<template>
      <transition name="modal">
        
        <div class="legend-seat-selection modal-mask"
        :style="{
          '--bgColor1': style.bgColor1,
          '--fontColor1': style.fontColor1,
          '--fontColor2': style.fontColor2,
          '--fontColor3': style.fontColor3,
          '--fontFamily': style.fontFamily,
          '--passengerSelectedColor': style.passengerSelectedColor,
          '--passengerSelectedFontColor': style.passengerSelectedFontColor,
        }"
        >
          <div class="modal-wrapper">
            <div class="modal-container">

              <div class="modal-header">
                <slot name="header">
                  <button @click="$emit('close')">
                    X
                  </button>
                  <div class="title">
                    <h3>{{ text.seat_information }}</h3>
                  </div>
                </slot>
              </div>

              <div class="modal-body">


                  <div v-if="flight.seatmap" 
    :class="`legend legend-frame ${flight.seatmap == null ? 'legend-seatmap-not-available' : ''}`"
    :style="{
      '--passengerSelectedColor': style.passengerSelectedColor,
      '--passengerSelectedFontColor': style.passengerSelectedFontColor,
      '--seatSelectedColor': style.seatSelectedColor,
      '--seatOccupiedColor': style.seatOccupiedColor,
      '--seatAvailable0Color': style.seatAvailable0Color,
      '--seatAvailable1Color': style.seatAvailable1Color,
      '--seatAvailable2Color': style.seatAvailable2Color,
      '--fontFamily': style.fontFamily,
      '--fontColor1': style.fontColor1,
      '--fontColor2': style.fontColor2,
      '--fontColor3': style.fontColor3,
    }"
  >

    <div class="legend--item-container" v-if="flight.seatmap">
      <div
        class="legend--single-item"
        v-for="(price, index) in priceMap"
        :key="`price_${index}`"
        :style="{
          '--seatAvailableColor': price.color,
        }"
      >
        <div
          class="seat"
          :class="`${
            price.hasOwnProperty('color')
              ? 'seat-available'
              : 'group-' + price.group
          } ${
            price.hasOwnProperty('meta') && price.meta.extraLeg
              ? 'extraleg'
              : ''
          }`"
        >
          <div class="seat-border"></div>
        </div>
        <div class="info">
          <strong>{{ price.label }} </strong>
          <span v-if="locale == 'he' ||  locale == 'ar'">
            <span
              > • {{ text.from }} <b>{{ formatCurrency(price.price) }}</b>
              {{ text.price_at_person }}</span
            >
          </span>
          <span v-else>
            • {{ text.from }} <b>{{ formatCurrency(price.price) }}</b> {{ text.price_at_person }} 
          
          </span>
          <span v-if="price.description && price.description.length > 0">• {{
            price.description
          }}</span>
        </div>
        
      </div>

<div class="info">
  <span v-if="locale == 'de' && (flight.airline =='FR' ||  flight.airline == 'W6')">
    {{ text.post_sale_price }}
  </span>
</div>
      <div class="legend--spacer"></div>
      <div class="legend--single-item">
        <div class="seat occupied">
          <div class="seat-border"></div>
        </div>
        <div class="info">
          <strong>{{ text.booked }}</strong>
        </div>
      </div>
      <div class="legend--single-item">
        <div class="seat selected-for-this-passenger">
          <div class="seat-border"></div>
        </div>
        <div class="info">
          <strong>{{ text.selected }}</strong>
        </div>
      </div>
    </div>

    <!--<div class="legend&#45;&#45;single-item">
      <a href="#" @click.prevent="handleRandomChoice">{{ text.select_automatically }}</a>
    </div>-->
  </div>
                 
              </div>

              <div class="modal-footer">
              </div>
            </div>
          </div>
        </div>
      </transition>
</template>
<script>

import { mapGetters } from "vuex";


export default {
  computed: {
    ...mapGetters(["style", "text", "priceMap", "formatCurrency", "locale", "flight"]),
  },
}
</script>
<style>
.modal-mask {
  position: absolute;
  bottom: 90px;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  z-index: 40;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: bottom;
}

.modal-container {
  width: 100%;
  margin: 0px auto;
  background-color: var(--bgColor1);
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);

  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;

}

.legend-seat-selection .modal-header{
  display: flex;
  justify-content: start;
  padding: 10px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
}

.legend-seat-selection .modal-header .title{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.legend-seat-selection .modal-header button{
  border: 0 !important;
  margin: 0 !important;
  background-color: var(--bgColor1) !important;
  color: var(--fontColor2) !important;
}

.legend-seat-selection .modal-header h3 {
  margin: 0;
  color: var(--fontColor2);
  text-align: center;
}

.legend-seat-selection .modal-body {
  margin: 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}





#seat-selector-container *{
    box-sizing: unset;
}

#ss-container .legend-frame{
   top: 100px !important;
}

#ss-container .legend h6 {
  font-size: 18px;
  margin: 0;
  margin-bottom: 20px;
  font-family: var(--fontFamily);
}
#ss-container .legend--single-item {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: flex-start;
  margin: 10px 0 20px;
}
#ss-container .legend--single-item a {
  height: 40px;
  width: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: center;
  font-family: var(--fontFamily);
  text-decoration: none;
  color: var(--passengerSelectedColor);
  border: 1px solid var(--passengerSelectedColor);
  border-radius: 2px;
  text-transform: uppercase;
  font-size: 13px;
  margin-top: 1rem;
}
#ss-container .legend--single-item a:hover {
  color: var(--passengerSelectedFontColor);
  background-color: var(--passengerSelectedColor);
}
#ss-container .legend--single-item .seat {
  margin-left: 0;
  margin-right: 15px;
  min-width: 36px;
}
#ss-container .legend--single-item .info {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: flex-start;
  align-items: flex-start;
  justify-content: flex-start;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  font-size: 16px;
  font-family: var(--fontFamily);
}
#ss-container .legend--single-item .info span {
  margin-top: 5px;
  font-size: 12px;
  color: var(--fontColor3);
}
#ss-container .legend--spacer {
  margin-top: 45px;
}
@media (max-width: 768px) {
  #ss-container .legend-on-top {
    max-width: 100%;
    position: relative;
    top: 100px;
  }
  #ss-container .legend-on-top h6 {
    margin-bottom: 10px;
  }
  #ss-container .legend-on-top .legend--single-item {
    margin-bottom: 5px;
    width: 50%;
  }
  #ss-container .legend-on-top .legend--spacer {
    margin-top: 5px;
  }
  #ss-container .legend-on-top .legend--item-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  #ss-container .legend-on-top h6 {
    font-size: 16px;
    text-align: center;
  }
  #ss-container .legend-on-top .legend--single-item .info {
    font-size: 12px;
  }
  #ss-container .legend-on-top .legend--single-item .info span {
    font-size: 11px;
  }
}
/*Medium devices (tablets, 768px and up)*/
@media (min-width: 768px) {
  #ss-container .legend {
    float: left;
    margin-top: 130px;
    margin-left: 80px;
    max-width: calc(305px - 2rem);
  }
  #ss-container .legend-on-top {
    float: right;
  }
}
/*Large devices (desktops, 992px and up)*/
@media (min-width: 992px) {
  #ss-container .legend {
    max-width: calc(280px - 2rem);
  }
}
/*Extra large devices (large desktops, 1200px and up)*/
@media (min-width: 1200px) {
  #ss-container .legend {
    max-width: calc(280px - 2rem);
  }
}

.info span {
      margin-top: 5px;
    font-size: 12px;
    color: var(--fontColor3);
}

.seatmap-not-available-title{
  text-align: center;
  margin-bottom: 10px !important;
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
}

.seatmap-not-available-info{
  text-align: center;
  letter-spacing: 0px;
  color: #858585;
  opacity: 1;
  margin-top:0px;
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
}
/* @media (min-width: 768px) {
  .seatmap-not-available {
    margin-left: 200px !important;
    white-space: nowrap;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/LegendModal.vue